import { DOWNLOAD_PROGRESS } from 'context/DownloadAssetsContext';
import { DOWNLAOD_MULTIPLE_ASSET, DOWNLOAD_READY_ASSETS_API, UPDATE_BANDWIDTH } from '../components/Dam/DAM_API/urls';
import Axios from './Axios';

export const startDownloadAssets = async (_data) => {
  const response = await Axios.post(DOWNLAOD_MULTIPLE_ASSET, _data, {
    validateStatus: () => true,
  });
  // async job created
  if (response.status === 202) {
    return {
      status: response.data?.status,
      downloadId: response.data?.requestId,
    };
  }

  // backend says ready immediately
  if (response.status === 200) {
    return {
      status: 'READY',
      downloadId: response.data?.id,
    };
  }

  throw new Error('Failed to start download');
};

const mapPhaseProgress = (phase, percent = 0) => {
  const cfg = DOWNLOAD_PROGRESS[phase];
  if (!cfg) return 0;

  if (cfg.start === cfg.end) return cfg.end;

  return Math.min(cfg.end, cfg.start + Math.floor(((cfg.end - cfg.start) * percent) / 100));
};

// export const downloadAssetsFile = async (_data, onProgress) => {
//   const response = await Axios.get(
//     `${DOWNLOAD_READY_ASSETS_API}/${_data.downloadId}`,
//     {
//       responseType: "blob",

//       onDownloadProgress: (e) => {
//         if (!e.total) return;

//         const rawPercent = Math.round(
//           (e.loaded * 100) / e.total
//         );

//         // 🔥 Dynamic mapping using config
//         const mappedPercent = mapPhaseProgress(
//           "DOWNLOADING",
//           rawPercent
//         );

//         if (onProgress) {
//           onProgress(mappedPercent);
//         }
//       },
//     }
//   );

//   if (response.status !== 200) {
//     throw new Error("File download failed");
//   }

//   const blob = new Blob([response.data], {
//     type: response.headers["content-type"],
//   });

//   const url = window.URL.createObjectURL(blob);
//   const link = document.createElement("a");

//   let filename = "images.zip";
//   const cd = response.headers["content-disposition"];
//   if (cd) {
//     const match = cd.match(/filename="(.+)"/);
//     if (match) filename = match[1];
//   }

//   link.href = url;
//   link.download = filename;

//   document.body.appendChild(link);
//   link.click();
//   link.remove();

//   window.URL.revokeObjectURL(url);
// };

export const downloadAssetsFile = async (_data, onProgress) => {
  let totalSize = 0; // cache once we successfully read it, avoid repeated header lookups

  const response = await Axios.get(`${DOWNLOAD_READY_ASSETS_API}/${_data.downloadId}`, {
    responseType: 'blob',

    onDownloadProgress: (e) => {
      if (!totalSize) {
        const xhr = e.target || e.event?.target; // xhr adapter: target is the XMLHttpRequest itself
        const customSize = xhr?.getResponseHeader?.('x-file-size');

        if (customSize) {
          totalSize = Number(customSize);
        } else if (e.total) {
          // fallback to content-length if custom header isn't exposed for some reason
          totalSize = e.total;
        }
      }

      if (!totalSize) return; // still nothing usable, skip this tick

      const rawPercent = Math.round((e.loaded * 100) / totalSize);
      const mappedPercent = mapPhaseProgress('DOWNLOADING', rawPercent);

      if (onProgress) {
        onProgress(mappedPercent);
      }
    },
  });

  if (response.status !== 200) {
    throw new Error('File download failed');
  }

  const blob = new Blob([response.data], {
    type: response.headers['content-type'],
  });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  let filename = 'images.zip';
  const cd = response.headers['content-disposition'];
  if (cd) {
    const match = cd.match(/filename="(.+)"/);
    if (match) filename = match[1];
  }

  link.href = url;
  link.download = filename;

  document.body.appendChild(link);
  link.click();
  link.remove();

  window.URL.revokeObjectURL(url);

  // --- download is now complete, report bandwidth usage ---
  // prefer the real blob size; fall back to the header value if needed
  const bytes = blob.size || totalSize || 0;
  const fileSizeMb = Number((bytes / (1024 * 1024)).toFixed(2)); // MB, 2 decimals

  try {
    await Axios.post(UPDATE_BANDWIDTH, {
      downloadBandWidth: fileSizeMb,
    });
  } catch (err) {
    // don't let a failed bandwidth report break the download UX
    console.error('update-bandwidth failed:', err);
  }
};
